module.exports = __webpack_public_path__ + "static/wordmark-003d6343619b9ad09a1465e945feaa86.svg";